
import React from "react";
import { i18nManager } from "../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { ApiResponseData, BaseService, EarningService, IMember, ITeam, ITeamAnalytics, ITeamMember, ITeamMemberEarning, ITeamTopProgram, ITeamTournament, ITeamTransaction, ITournamentEdition, SanitizedResponse, TeamRole, TeamService, TeamTournamentStatus, TransactionFlow, TournamentService, TransactionSourceType } from "../../../../services";
import { ChartData, ChartType, Classname, Column, DateHelper, DateTimeInput, DateTimePickerLayout, DateTimePickerSelectionMode, Dropdown, FormControl, Table } from "@rivtn/noseur";
import { Schemes, Utils } from "../../../../utils";
import { Elements } from "../../../shared/Elements";
import { ChartManager } from "../../../shared/ChartManager";
import AnalCard from "../../../shared/analytics/AnalCard";

export interface TeamTournamentAnalyticsProps {
    profile: IMember;
}

function TeamTournamentAnalytics(props: TeamTournamentAnalyticsProps) {

    const { profile } = props;
    const teamService = TeamService.getInstance();
    let { id: teamId = "" } = ReactRouterDom.useParams();
    const analLabels = i18nManager.Labels.teams.analytics;
    const [team, setTeam] = React.useState<ITeam>({} as any);
    const teamAnalyticsChartDataState = React.useState<ChartData>();
    const labels = i18nManager.Labels.teams.analytics.tournaments_page;
    const [daysDifference, setDaysDifference] = React.useState<number>(0);
    const [teamAnalytics, setTeamAnalytics] = React.useState<ITeamAnalytics>();
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const [teamTournaments, setTeamTournaments] = React.useState<ApiResponseData<ITeamTournament>>({});

    React.useEffect(fetchInformation, []);

    React.useEffect(() => {
        setDaysDifference(DateHelper.getDaysBetweenDates(
            (searchParams.has("from") ? new Date(searchParams.get("from")!) : DateHelper.getStartOfMonth()),
            (searchParams.has("to") ? new Date(searchParams.get("to")!) : new Date())));
    }, [searchParams]);

    return (<div className="earnings analytics">
        <div className="header">
            <div className="l" style={{ display: "flex", flexDirection: "column" }}>
                <span className="t lined-limit"><i className="fa fa-arrow-left" onClick={() => window.history.back()} />
                    {i18nManager.Labels.teams.title + " - " + teamId + " - " + analLabels.title + " - " + labels.title}</span>
                <span className="lined-limit" style={{ marginLeft: 25, fontWeight: "normal" }}>
                    {team.name}{" "}
                </span>

            </div>
            <div className="queries">
                <Dropdown noIcon scheme={Schemes.OMNEHOST} formControlProps={{ className: "plan-dd", isFieldset: true, label: analLabels.country_currency, }}
                    selectedOptionIndex={(i18nManager.CountriesAndCurrencies?.findIndex((p) => p?.currency_code === (searchParams.get("curr") ?? "NGN")) ?? 0)}
                    textInputProps={{ style: { paddingLeft: 15 } }}
                    options={i18nManager.CountriesAndCurrencies} optionMap={{
                        value: "currency_code",
                        label: "{label} ({currency_name} - {currency_code})",
                    }} onSelectOption={(option) => {
                        Utils.updateSearchParams("curr", option.currency_code, setSearchParams, fetchInformation);
                    }} />
                <FormControl className="date-range-dd" isFieldset scheme={Schemes.OMNEHOST} label={analLabels.date_range} rightContent={"fa fa-calendar"} style={{ width: 360 }}>
                    <DateTimeInput fill leftLayout={DateTimePickerLayout.FINE_LEFT_LAYOUT} formatDate={(date) => Utils.formatToFineDate4(date)}
                        selectedDates={[(searchParams.has("from") ? new Date(searchParams.get("from")!) : DateHelper.getStartOfMonth()), new Date(searchParams.get("to") ?? Utils.formatToApiDate(new Date(), false, false)!)]}
                        selectionMode={DateTimePickerSelectionMode.RANGE} onSelectDate={(options) => {
                            Utils.updateSearchParamses({
                                "to": Utils.formatToApiDate(options.toDate!, false, false),
                                "from": Utils.formatToApiDate(options.fromDate!, false, false),
                            }, setSearchParams, fetchInformation);
                        }} />
                </FormControl>
            </div>
        </div>
        <div className="container" style={{ flexDirection: "column" }}>
            <div className="primary" style={{ flex: "unset" }}>
                <div className="anal-cards" style={{ marginLeft: -10 }}>
                    <AnalCard anal={teamAnalytics?.tournaments?.entered} desc={labels.tours_entered} analKey="count" cardColor={"#EBFEF6"}
                        icon="fas fa-basketball-ball" title={labels.entered} daysDifference={daysDifference} />
                    <AnalCard anal={teamAnalytics?.tournaments?.participate} desc={labels.tours_participation} analKey="count" cardColor={"#EBFEF6"}
                        icon="fas fa-basketball-ball" title={labels.participate} daysDifference={daysDifference} />
                    <AnalCard anal={teamAnalytics?.tournaments?.won} desc={labels.tours_won} analKey="count" cardColor={"#EBFEF6"}
                        icon="fas fa-basketball-ball" title={labels.won} daysDifference={daysDifference} />
                    <AnalCard anal={teamAnalytics?.tournaments?.lost} desc={labels.tours_lost} analKey="count" cardColor={"#EBFEF6"}
                        icon="fas fa-basketball-ball" title={labels.lost} daysDifference={daysDifference} />
                    <AnalCard anal={teamAnalytics?.tournaments?.skipped} desc={labels.tours_skip}
                        daysDifference={daysDifference} analKey="count" cardColor={"#EBFEF6"} style={{ maxWidth: 150 }} />
                </div>
            </div>
            <div className="analytics" style={{ flex: 1 }}>
                <div className="container" style={{ marginTop: 0 }}>
                    <div className="primary" style={{ marginTop: -10, marginBottom: 0, flex: 0.7 }}>
                        {<ChartManager height={"unset"} type={ChartType.BAR} title={analLabels.team_anals} chartDataState={teamAnalyticsChartDataState} style={{ height: "100%", marginBottom: 10 }} />}
                    </div>
                    <div className="secondary" style={{ marginTop: 5, flex: 1 }}>
                        <div className="anal-table" style={{ margin: 10, display: "flex", flexDirection: "column" }}>
                            <div className="header">
                                <span className="t">{labels.all_tours}</span>
                                <span className="link">{labels.export}</span>
                            </div>
                            {Elements.buildConfirmDialogForm(labels.query_inputs, (name: string, value: any, searching: any) => {

                            }, {}, undefined, { maxWidth: "70%", marginTop: 0, flexDirection: "row", alignItems: "center" }, undefined, {
                                marginRight: 15
                            })}
                            <Table stripedRows scheme={Schemes.OMNEHOST} data={teamTournaments.content} totalRecords={teamTournaments.total_elements} dataRefreshKeys={["external_id", "created_at"]}
                                style={{ flex: 1 }} rowsPerPage={200} loadingState={Elements.LOADING_STATE} emptyState={Elements.buildEmptyListView("fa fa-circle", (<span>
                                    {labels.empty_label_parts.no_records_found}{" "}
                                    <ReactRouterDom.NavLink to="/tournaments">{labels.empty_label_parts.participate}</ReactRouterDom.NavLink>{" "}
                                    {labels.empty_label_parts.in_a_tour}
                                </span>), { marginTop: 50 })}>
                                <Column className="table-c" header={labels.table.headers.registration_date} dataKey="registration_date" template={(v) => Utils.formatToFineDate(v, true)} />
                                <Column className="table-c" header={labels.table.headers.tournament} dataKey="tournament" template={(v: ITournamentEdition) => {
                                    let link = EarningService.buildTransactionSourceLink({ source_data: { type: TransactionSourceType.TOURNAMENT, extra_data: { public_id: v.tournament.public_id } } as any });
                                    return (<div style={{ display: "flex", flexDirection: "row", alignItems: "center", }}>
                                        <img alt={v.name} src={v.logo_url} style={{ width: 20, height: 20, marginRight: 10, borderRadius: "100%" }} />
                                        <a target="_blank" href={link}>{v.name}</a>
                                    </div>);
                                }} />
                                <Column className="table-c" header={labels.table.headers.status} dataKey="status" template={(v) => buildStatusLabel(v)} />
                                <Column className="table-c" header={labels.table.headers.participants} dataKey="participants" template={(v: ITeamMember[]) => {
                                    return (<div className="team-anals-participants">
                                        {v.slice(0, 4).map((m) => (<img key={m.external_id} alt={m.display_name} src={m.passport_picture_url} />))}
                                        {v.length > 4 && (<span>+{v.length - 4}</span>)}
                                    </div>);
                                }} />
                            </Table>
                            <div className="pagination">
                                {Elements.buildPaginator(teamTournaments ?? {},
                                    ({ currentPage }, size) => Utils.updateSearchParamses({ "page": currentPage, size }, setSearchParams, fetchInformation),
                                    parseInt(searchParams.get("page") ?? "1"), { margin: 15, marginBottom: 5 })}
                                {Elements.buildSorter(labels.sorts, (sort) => Utils.updateSearchParamses({ sort }, setSearchParams, fetchInformation), labels.sorts[0].label)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>);

    function fetchInformation() {
        teamService.getTeamByPublicId(teamId!).then(({ sanitized }: SanitizedResponse<ITeam>) => {
            setTeam(sanitized);
        }).catch(BaseService.reportError);

        const params = {
            currency_code: searchParams.get("curr") ?? "NGN",
            to: searchParams.get("to") ?? Utils.formatToApiDate(new Date())!,
            fields: ["earnings.total", "tournaments.entered", "achievements.total"],
            from: searchParams.get("from") ?? Utils.formatToApiDate(DateHelper.getStartOfMonth())!,
        };
        setTeamAnalytics(undefined);
        teamService.getTeamAnalytics(teamId, params).then(({ sanitized }: SanitizedResponse<ITeamAnalytics>) => {
            setTeamAnalytics(sanitized);
        }).catch(BaseService.reportError);

        teamAnalyticsChartDataState[1](undefined);
        teamService.queryAnalyticsChartData(teamId, params).then(({ apiResponse }: SanitizedResponse<any>) => {
            teamAnalyticsChartDataState[1](apiResponse.data!);
        }).catch(BaseService.reportError);

        setTeamTournaments({});
        teamService.queryTeamTournaments(teamId, params).then(({ apiResponse }: SanitizedResponse<any>) => {
            setTeamTournaments(apiResponse.data!);
        }).catch(BaseService.reportError);
    }

    function buildStatusLabel(status: TeamTournamentStatus) {
        const color = {
            [TeamTournamentStatus.WON]: "#20C173",
            [TeamTournamentStatus.LOST]: "#FF7171",
            [TeamTournamentStatus.SKIPPED]: "#000000",
            [TeamTournamentStatus.ENTERED]: "#71A1FF",
            [TeamTournamentStatus.PARTICIPATING]: "#FFBE71",
        }[status];
        const label = labels.query_inputs.find((i) => i.name === "status")?.options?.find((o) => o.value === status)?.label ?? status;
        return (<span style={{ fontWeight: "bold", color }}>{label}</span>);
    }

}

export default TeamTournamentAnalytics;
